var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#006EC2",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.278 27.8066V42.1938L40.5091 34.4249L39.0208 35.9133L46.6524 43.5555H20.4747L27.8635 35.9133L26.3435 34.446L18.7224 42.331V24.0488L31.843 37.106C32.2385 37.4992 32.7736 37.7199 33.3313 37.7199C33.8891 37.7199 34.4241 37.4992 34.8197 37.106L44.1402 27.8383C43.3962 27.6447 42.6848 27.3424 42.0291 26.941L33.3102 35.6071L20.1052 22.4444H38.5774C38.3735 21.7587 38.2634 21.0485 38.2502 20.3333H18.7224C18.1625 20.3333 17.6256 20.5557 17.2297 20.9516C16.8337 21.3475 16.6113 21.8845 16.6113 22.4444V43.5555C16.6113 44.1154 16.8337 44.6523 17.2297 45.0483C17.6256 45.4442 18.1625 45.6666 18.7224 45.6666H48.278C48.8379 45.6666 49.3749 45.4442 49.7708 45.0483C50.1667 44.6523 50.3891 44.1154 50.3891 43.5555V26.8777C49.7345 27.2887 49.0233 27.6017 48.278 27.8066Z",
    fill: "#006EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1664 25.4633C49.0813 25.4633 51.4442 23.1003 51.4442 20.1855C51.4442 17.2707 49.0813 14.9077 46.1664 14.9077C43.2516 14.9077 40.8887 17.2707 40.8887 20.1855C40.8887 23.1003 43.2516 25.4633 46.1664 25.4633Z",
    fill: "#006EC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(14.5 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.a5a7ace06fa1e346333ad537bcb80180.svg";
export { ForwardRef as ReactComponent };